import React, { Fragment, useState, useEffect } from "react";
import dayjs from "dayjs";
import Pagination from "../plugins/Pagination";
import Spinner from "../plugins/Spinner";
import usePage from "../../hooks/usePage";
import useAPI from "../../hooks/useAPI";
import Header from "../layout/Header";
import { useNavigate, Link } from "react-router-dom";
import styled from "styled-components";
import Modal from "../layout/Modal";
import Select from "react-select";

import { FaEye } from "react-icons/fa";
import { BsFillTelephoneFill, BsSearch } from "react-icons/bs";
import {sendToast} from "../plugins/toastAll";
import { ToastContainer } from "react-toastify";
import { useForm } from "react-hook-form";
import { Tooltip } from "react-tooltip";
import { TiExport } from "react-icons/ti";
import { IoClose } from "react-icons/io5";
import { Toaster } from "react-hot-toast";

const messageTemplatesConfig = [
  { label: "Mensaje para notificar pago recibido:", name: "payment" },
  { label: "Mensaje para notificar orden enviada:", name: "sent" },
  { label: "Mensaje para notificar orden cancelada:", name: "cancelled" },
];

const ConsumptionPayments = () => {
  const [data, setData] = useState([]);
  const [dataTable, setDataTable] = useState([]);
  const [loading, setLoading] = useState(false);
  const [validation, setValidation] = useState(false);
  const [search, setSearch] = useState("");
  
  const [modalConfig, setModalConfig] = useState(false);
  const [notifyCheck, setNotifyCheck] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [isDark, setIsDark] = useState(false);
  const [selectedTemplates, setSelectedTemplates] = useState({
    payment: null,
    sent: null,
    cancelled: null,
  });
  const [formError, setFormError] = useState(false);
  const [isView, setIsView] = useState(false);
  const [headerType, setHeaderType] = useState(false);
  const [textHeader, setTextHeader] = useState(false);
  const [templateBody, setTemplateBody] = useState(false);
  const [textFooter, setTextFooter] = useState(false);
  const [templateButtons, setTemplateButtons] = useState(false);
  const [date, setDate] = useState("");
  const [buttonTextFastAnswer, setButtonTextFastAnswer] = useState("");
  const [buttonTextFastAnswer2, setButtonTextFastAnswer2] = useState("");
  const [templatename, setTemplatename] = useState("");

  //# Custoom Hooks
  const { page, byPage, resetPage, setPage } = usePage();
  const { urlAPI_1, urlAPI_2, fetchWithAuth } = useAPI();

  const formConfig = useForm();
  const error1 = formConfig.formState.errors;

  useEffect(() => {
    getCompanie();
    getOrders();
    getTemplates();
  }, []);

  const token = localStorage.getItem("USER_TOKEN");
  const navigate = useNavigate();

  // Obtener data de la compañía
  const getCompanie = async () => {
    const resultIdCompany = localStorage.getItem('ID_COMPANY');
    console.log('resultIdCompany: ', resultIdCompany);
    try {
      const url = urlAPI_2 + 'companies/' + resultIdCompany;
      const options = { method: 'GET', mode: 'cors' };
      const response = await fetchWithAuth(url, options);
      const result = await response.json();
      console.log('↗companie↗: ', result);
      if (result.code === 0) {
        return null;
      } else if (!result.data) {
        return null;
      } else {
        const data = result.data[0].orderSettings || null
        if (data.notifyStatus) {
          console.log('---- Si hay notifyStatus ----');
          if (data.notifyStatus.isActive) {
            console.log('---- ESTA ACTIVE ----');
            const initialState = {};
            data.notifyStatus.states.forEach((state) => {
              if (state.template && state.template._id) {
                if (state.value === 1) initialState.payment = state.template;
                if (state.value === 2) initialState.sent = state.template;
                if (state.value === 3) initialState.cancelled = state.template;
              }
            });
            console.log('👉', initialState);
            
            setSelectedTemplates(initialState);
            setNotifyCheck(true);
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  //#--> Obtener todas las ordenes
  const getOrders = async () => {
    try {
      setLoading(true);
      const url = urlAPI_2 + "getOrders";
      const options = { method: "GET", mode: "cors"};
      const response = await fetchWithAuth(url, options);
      const result = await response.json();
      console.log("Lista de pedidos.........", result);

      if (result.code === 0) {
        sendToast(result)
      } else if (result.data.length === 0) {
        setValidation(true);
        setData([]);
        setDataTable([])
      } else {
        setData(result.data);
        setDataTable(result.data)
        setValidation(false);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  // Obtener lista de plantillas donde se filtra para mostrar solo las activas y que no tengan contenidos con variables o medios
  const getTemplates = async () => {
    const dark = localStorage.getItem("THEME");
    setIsDark(dark);
    try {
      const url = urlAPI_2 + "templates";
      const options = { method: "GET", mode: "cors"};
      const response = await fetchWithAuth(url, options);
      const result = await response.json();
      console.log("Plantillas=========>>", result.data);
      if (result.type != "success") {
        setTemplates([]);
      } else {
        // const resTemplates = result.data.filter(res => {
        //   if((res.status === "APROBADA" && res.isActive === true) && res.content) return res
        // })
        const resTemplates = result.data.filter(res => {
          if (res.status === "APROBADA" && res.isActive === true && res.content && res.category == "UTILITY") {
            const body = res.content.find(part => part.type === "BODY");
            const header = res.content.find(part => part.type === "HEADER");

            // Verifica si el BODY tiene variables
            const bodyHasVars = body && body.text ? /{{\d+}}/.test(body.text) : false;
            if (bodyHasVars) return false;

            // Si hay HEADER y no es de tipo TEXT, se excluye
            if (header && header.format !== "TEXT") return false;

            // Si el HEADER es de tipo TEXT y tiene texto con variables, se excluye
            const headerHasVars = header && header.format === "TEXT" && /{{\d+}}/.test(header.text);
            if (headerHasVars) return false;

            return true;
          }

          return false;
        });
        setTemplates(resTemplates);
      }
    } catch (error) {
      console.log("error on actualizar", error);
      return null;
    }
  };

  //#--> Busqueda de ordenes
  const searchQuery = (searchTerm) => {
    var searchResults = dataTable.filter((element) => {
      if (
        element.client.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
        element.phoneNumber.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
        element.id.toString().toLowerCase().includes(searchTerm.toLowerCase()) 
      ) {
        return element;
      }
    });
    setData(searchResults);
    if (searchResults.length === 0) {
      setValidation(true);
    } else {
      setValidation(false);
    }
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? 'lightblue' : '#fff',
      color: state.isSelected ? '#333' : '#333',
      '&:hover': {
        backgroundColor: 'lightgray',
        color: '#333',
        cursor: 'pointer',
      },
    }),
  };    
  
  const customStylesDark = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#455a64' : '#202c33',
      color: state.isSelected ? 'white' : 'white',
      '&:hover': {
        backgroundColor: '#374954',
        color: 'white',
        cursor: 'pointer',
      },
    }),
  };

  const formatOrders = [...data].reverse();

  const saveConfig = async () => {
    const { payment, sent, cancelled } = selectedTemplates;

    if (notifyCheck && (!payment || !sent || !cancelled)) {
      setFormError(true);
      return;
    }

    setFormError(false);    
    setModalConfig(false);    
    console.log("IsActive: ", notifyCheck);

    const data = {
      notifyStatus: {
        isActive: notifyCheck,
        states: [
          {
            value: 1,
            template: selectedTemplates.payment
          },
          {
            value: 2,
            template: selectedTemplates.sent
          },
          {
            value: 3,
            template: selectedTemplates.cancelled
          }
        ] 
      }
    }

    try {
        setLoading(true);
        const url = urlAPI_2 + `saveConfigOrder`;
        const options = { method: "PUT", mode: "cors", body: JSON.stringify(data)};
        const response = await fetchWithAuth(url, options);
        const result = await response.json();
        console.log("Result API: automaticSave: ", result);
        setModalConfig(false)
        getCompanie();
        setLoading(false);
    } catch (error) {
      console.error('❌ Error al enviar data para guardar plantillas: ', error);
    }

  }

  // Evento cuando se selecciona plantilla
  const handleChange = (name, selected) => {
    setSelectedTemplates((prev) => ({ ...prev, [name]: selected }));
    console.log(selectedTemplates);
  };

  // Evento cuando presionamos el ojo para ver la plantilla
  const onViewTemplate = (template) => {
    const hour = new Date();
    setDate(hour);
    setTemplatename(template.name)
    const content = template.content;
    for(var cont of content){
      var objHeader = {};
      if (cont.type === 'HEADER') {
        objHeader = cont;
        // console.log('=> SI HAY HEADER', objHeader);
        setHeaderType(objHeader.format);
        setTextHeader(objHeader.text);
      }
      
      var objBody = {};
      if (cont.type === 'BODY') {
        objBody = cont;
        // console.log('=> SI HAY BODY', objBody);
        setTemplateBody(objBody.text);
      }
      
      var objFooter = {};
      if (cont.type === 'FOOTER') {
        objFooter = cont;
        // console.log('=> SI HAY FOOTER', objFooter);
        setTextFooter(objFooter.text);
      }

      var objButtons = {};
      if (cont.type === 'BUTTONS') {
        objButtons = cont;
        // console.log('=> SI HAY BUTTONS', objButtons);
        setTemplateButtons(objButtons);
      }
    }
  }

  return (
    <Fragment>
      {loading ? (
        <div className="content-spinner">
          <Spinner />
        </div>
      ) : null}

      <div className="m-auto container-fluid p-0">
        <div className="col-xs-9 heading">
          <div className="mt-2">
            <h1>Pedidos</h1>
            <input
                type="button"
                className="btn btn-default"
                value="Configuraciones"
                onClick={() => {
                  setModalConfig(true)
                }}
              />
          </div>
          <Header />
        </div>

        <header>
          <div style={{ float: "right" }}>
            <form className="form-inline">
              <div className="su-control my-1">
                <input
                  className="form-control"
                  type="text"
                  placeholder="Búsqueda"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    searchQuery(e.target.value);
                    resetPage(1);
                  }}
                />
                <button
                  className="btn btn-info"
                  type="button"
                  id="buttonSearchProductBack"
                  style={{ height: "34px" }}
                >
                  <BsSearch />
                </button>
              </div>
            </form>
          </div>
        </header>

        <div className="container-fluid mt-3 px-0" style={{ height: "580px", overflow: "auto" }}>
          <table className="table table-striped invoiceList">
            <thead>
              <tr>
                <th>Detalle</th>
                <th>Número de orden</th>
                <th>Cliente</th>
                <th>Articulos</th>
                <th>Valor</th>
                <th>Valor envío</th>
                <th>Fecha</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {formatOrders && formatOrders.map((order, d) => (
                <tr key={d}>
                  <td>
                    <div className="d-flex align-items-center justify-content-center">
                      <div className="dropdown">
                        <button
                          className="border-0 bg-transparent d-block pointer mt-2"
                          onClick={() => {navigate(`/home/order/${order._id}`)}}
                        >
                          <FaEye style={{ fontSize: "18px", color: "#ff9317" }} />
                          <span className="text-dark ml-2 f-14"></span>
                        </button>
                      </div>
                    </div>
                  </td>
                  <td>{order.id}</td>
                  <td>
                    <Link
                      className="hover-a"
                      to={`/home/contact/${order.clientId}`}
                    >
                      {order.client}
                    </Link>
                  </td>
                  <td>{order.articles}</td>
                  <td>{order.total}</td>
                  <td>$ 0</td>
                  <td>
                    {
                      dayjs(order.created)
                        .locale('es')
                        .format("DD MMMM YYYY")
                    }
                  </td>
                  <td className="status-campaign">
                    <p>
                      <a
                        href="javascript:;"
                        className={
                          order.status === 4 ? "gray"
                          : order.status === 1 ? "blue" 
                          : order.status === 3 ? "red" 
                          : "green" 
                        }
                      >
                        {
                          order.status === 4 ? "En proceso"
                          : order.status === 1 ? "Pago notificado" 
                          : order.status === 3 ? "Orden cancelada" 
                          : "Envio notificado"
                        }
                      </a>
                    </p>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {validation && (
            <h1 className="text-center mt-3">
              No existen registros en el sistema
            </h1>
          )}
        </div>

        <footer>
          <div className="row">
            <div className="col-md-8"></div>
            <div className="col-md-4">
              <Pagination
                totalData={data.length}
                byPage={byPage}
                setPage={setPage}
              />
            </div>
          </div>
        </footer>
      </div>

      {/* Modal para mostrar configuraciones */}
      <Modal
        status={modalConfig}
        changeStatus={setModalConfig}
        title= "Configuraciones"
        width={isView ? "800" : "700px"}
      >
        <Content>
          <form style={{ width: "100%" }} onSubmit={formConfig.handleSubmit(saveConfig)}>
            
            <div className="su-control mt-2" 
              // style={{ overflow: "auto", height: "400px"}}
            >
              <div className="d-flex align-items-center justify-content-between" 
                // style={{flexDirection: "column"}}
              >
                <label className="" style={{width: "85%"}}>¿Deseas notificar al cliente el cambio de estado de la orden por WhatsApp?: </label>
                <input
                  name="notify"
                  id="notifyActiveId"
                  type="checkbox"
                  className="cmn-toggle cmn-toggle-round-flat"
                  checked={notifyCheck}
                  onChange={(e) => {setNotifyCheck(e.target.checked)}}
                />
                <label className="mr-1 mb-0" htmlFor="notifyActiveId"></label>
              </div>
              {notifyCheck && (
                templates.length > 0 ? (
                  <div className="mt-3">
                    <label>Selecciona las plantillas: </label>
                    <p style={{fontSize: "1em", fontStyle: "italic"}}>
                      Debes seleccionar una plantilla para cada uno de los estados, tener en cuenta que estas deben ser de categoría <strong>&quot;Utilidad&quot;</strong>.
                    </p>
                    <div className="d-flex justify-content-between">
                      <div className="mt-3" style={isView ? {width: "50%"} : {width: "100%"}}>
                        {messageTemplatesConfig.map((config, index) => (
                          <div className="su-control-group mt-2" key={index}>
                            <label>{config.label}</label>
                            <div className="d-flex align-items-center">
                              <Select
                                styles={isDark === 'true' ? customStylesDark : customStyles}
                                className="form-control select-template"
                                placeholder="Selecciona una plantilla"
                                name={config.name}
                                value={selectedTemplates[config.name] || null}
                                options={templates}
                                getOptionLabel={(option) => (
                                  <div className="option d-flex" style={{ fontSize: "15px" }}>
                                    {`${option.name} - (${option.language})`}
                                  </div>
                                )}
                                getOptionValue={(option) => `${option.name} - ${option.language}`}
                                onChange={(selected) => handleChange(config.name, selected)}
                              />
                              {selectedTemplates[config.name] && (
                                <FaEye 
                                  className="pointer ml-2" 
                                  style={{fontSize: "18px",color: "#ff9317",}} 
                                  onClick={() => {
                                    onViewTemplate(selectedTemplates[config.name])
                                    setIsView(true)
                                  }}
                                  data-tooltip-id="my-tooltip" 
                                  data-tooltip-content={`Ver plantilla seleccionada.`}
                                />
                              )}
                            </div>
                          </div>
                        ))}

                        {formError && <Alert>* Debes seleccionar una plantilla para cada uno de los estados antes de guardar.</Alert>}

                      </div>
                      {isView && (
                        <div className="ml-2 mt-3" style={{width: "50%"}}>
                          <section className="section-preview p-2" style={{height: "auto"}}>
                            <div className="d-flex align-items-center justify-content-between">
                              <label>Vista previa de: <strong style={{fontSize: "1.1em", fontStyle: "italic"}}>{templatename}</strong></label>
                              <IoClose 
                                className="icon-cancel pointer" 
                                style={{ fontSize: "1.5rem", zIndex: "9" }} 
                                onClick={() => setIsView(false)} 
                                data-tooltip-id="my-tooltip" 
                                data-tooltip-content={`Cerrar vista previa.`}  
                              />
                            </div>
                            <div className="section-div1 ml-1 mr-1">
                              <div className="section-div2">
                                <div className="section-div3">
                                  <div className="section-div4">
                                    <div className={headerType === "TEXT" ? "header-preview headerText" : "header-preview"}>
            
                                      {headerType === "TEXT" && textHeader}
            
                                      {headerType === "IMAGE" ? (
                                        <div className="medio-image custom-media"></div>
                                      ) : headerType === "VIDEO" ? (
                                        <div className="medio-video custom-media"></div>
                                      ) : headerType === "DOCUMENT" ? (
                                        <div className="medio-document custom-media"></div>
                                      ) : headerType === "LOCATION" ? (
                                        <div className="medio-location custom-media"></div>
                                      ) 
                                      : null}                      
            
                                    </div>
            
                                    {headerType === "LOCATION" && 
                                      <div className="data-location">
                                        <div className="location-name">{"{{Location name}}"}</div>
                                        <div className="location-adress">{"{{Adress}}"}</div>
                                      </div>
                                    }
            
                                    <div className="section-div5">
                                      <span className="span">
                                        <span>{templateBody && templateBody}</span>
                                      </span>
                                    </div>
            
                                    {textFooter && (<div className="content-footer">{textFooter}</div>)}
            
                                    <time aria-hidden="true" className="_6xe5">{dayjs(date).locale("es").format("hh:mm a")}</time>
                                  </div>
            
                                  <div className="content-botton">
                                    {templateButtons && templateButtons.buttons.map((tem, b) => (<>
                                      {tem.type === "PHONE_NUMBER" ? 
                                          <div key={b}>
                                              <BsFillTelephoneFill className="mr-1" style={{ fontSize: "1.3rem"}}/>
                                              <span>{tem.text}</span>
                                          </div>
            
                                      : tem.type === "URL" ?
                                          <div key={b}>
                                            <TiExport className="mr-1" style={{ fontSize: "1.3rem"}}/>
                                            <span>{tem.text}</span>
                                          </div>
            
                                      : null }
                                    </>))}
                                  </div>
            
                                </div>
            
                                {templateButtons && templateButtons.buttons.map((tem, k) => (<>
            
                                  {tem.type === "QUICK_REPLY" ?
                                    <div key={k} className="content-fastAnswer">
                                      <div>
                                        <span>{tem.text}</span>
                                      </div>
                                    </div>
                                    
                                  : 
                                    null 
                                  }
            
                                </>))}
            
                                {buttonTextFastAnswer && (
                                  <div className="content-fastAnswer">
                                    <div>
                                      <span>{buttonTextFastAnswer}</span>
                                    </div>
            
                                    {buttonTextFastAnswer2 && (
                                      <div>
                                        <span>{buttonTextFastAnswer2}</span>
                                      </div>
                                    )}
                                  </div>
                                )}
            
                              </div>
                            </div>
                          </section>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="mt-5 text-center">
                    <h5>No tienes plantillas disponibles </h5>
                    <p style={{fontSize: "1em", fontStyle: "italic"}}>
                      Para crear plantilla selecciona el siguiente botón, recuerda que deben ser de categoría <strong>&quot;Utilidad&quot;</strong>.
                    </p>
                    <input
                      type="button"
                      className="btn btn-lg btn-info mt-3"
                      value="Ir a crear plantilla"
                      onClick={() => {navigate(`/home/templates`)}}
                    />
                  </div>
                )
              )}
            </div>


            <div className="row justify-content-end bd col-12 mt-4 ml-1">
              <a
                href="javascript:;"
                className="btn btn-lg btn-default mr-1"
                onClick={() => {
                  setModalConfig((prevMessage) => { return false});
                }}
              >
                Cancelar
              </a>
              
              <input
                className="btn btn-lg btn-info"
                type="submit"
                value="Guardar"
                // onClick={() => window.location.href = "/#/home/paymentMethods"}
              />
            </div>
          </form>


        </Content>
      </Modal>

      <Tooltip 
        id="my-tooltip" 
        style={{ zIndex: 9999, backgroundColor: "black", color: "white", padding: "5px 10px", borderRadius: "5px", whiteSpace: "pre-line", maxWidth: "500px" }} 
      />

      <Toaster />
      {/* <ToastContainer 
        position="top-center"
        autoClose={52000}
        // autoClose={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        // draggable
        theme={JSON.parse(localStorage.getItem("THEME")) ? "dark" : "light"}
        toastClassName="custom-toast" // Aplica estilos personalizados a cada toast individualmente
        bodyClassName="custom-toast-body"
      /> */}

    </Fragment>
  );
};

export default ConsumptionPayments;

const Alert = styled.span`
  color: red;
  display: block;
  width: 100%;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  h1 {
    font-size: 42px;
    font-weight: 700;
    margin-bottom: 10px;
    text-align: center;
  }
  li {
    padding: 10px 5px;
    border-bottom: 1px solid rgb(0, 0, 0, 0.05);
  }
  li:hover {
    background: rgb(0, 0, 0, 0.05);
  }
  p {
    font-size: 18px;
    margin-bottom: 0px;
  }
  input {
    padding: 10px;
    border-radius: 0px;
    font-size: 17px;
  }
  img.img-answer {
    cursor: pointer;
    width: auto;
    height: 180px;
    object-fit: scale-down;
  }
  .content-img {
    position: relative;
  }
  // .content-img .icon-eye {
  //   cursor: pointer;
  //   position: absolute;
  //   top: 50%;
  //   left: 50%;
  //   transform: translate(-50%, -50%);
  // }
  .content-img img:hover {
    opacity: 0.6;
  }
`;